export const AUTOCOMPLETE_SEARCH_FROM = {
  DEFAULT: 'DEFAULT',
  BASICPROMO: 'BASICPROMO',
  BASICPROMOEXTRA: 'BASICPROMOEXTRA',
  ADVANCEBUYPROMO: 'ADVANCEBUYPROMO',
  ADVANCEBUYPROMOEXTRA: 'ADVANCEBUYPROMOEXTRA',
  ADVANCESPENDPROMO: 'ADVANCESPENDPROMO',
  ADVANCESPENDPROMOEXTRA: 'ADVANCESPENDPROMOEXTRA',
  REWARDADD: 'REWARDADD',
  ADVREWARDEXTRA: 'ADVREWARDEXTRA'
}

export const PROD_SEARCH_ENTITIES = {
  Search_By_Product: 1,
  Search_By_Category: 2,
  Search_By_Brand: 3,
  Search_By_Tags: 4,
  Search_By_SKUs: 5,
  Search_By_Supplier: 6
}
